export const TRACKER_TYPE = 'trackStructEvent';
export const CATEGORY = 'search_shortcut_info_notice';
export const LABEL = 'serp_page';
export const ACTION_IMPRESSION = 'display';
export const ACTION_CLICK = 'click';
export const CONTEXT = ['abTests'];

export const trackSearchShortcutInfoBoxImpression = () => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_IMPRESSION,
    label: LABEL,
    property: '',
    value: '0',
  },
  context: CONTEXT,
});

export const trackSearchShortcutInfoBoxClick = (position) => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_CLICK,
    label: LABEL,
    property: 'box',
    value: position || '0',
  },
  context: CONTEXT,
});

export const trackSearchShortcutMoreLinkClick = () => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_CLICK,
    label: LABEL,
    property: 'more',
    value: '0',
  },
  context: CONTEXT,
});
